import TYPES from './types'

export const primaryTabUpdate = payload => ({
  type: TYPES.PRIMARY_TAB.UPDATE,
  payload,
})
